<template>
  <v-fade-transition>
    <div v-if="show">
      <p class="font-weight-bold">
        {{ $t('You have used') }} {{ storageInfo.used_formatted }} / {{ storageInfo.limit_formatted }}
      </p>
      <v-progress-linear
        :color="color"
        :value="storageInfo.used_percentage"
        height="25"
        class="mb-4"
      >
        <strong>{{ storageInfo.used_percentage.toFixed(2) }}%</strong>
      </v-progress-linear>
      <v-alert
        v-if="storageInfo.used_percentage > 100"
        type="info"
      >
        {{ $t("Your media library has exceeded the storage limit. You will still be able to create questions and answers, but you won't be able to upload new images or files until you upgrade your plan or remove files from your media library.") }}
      </v-alert>
    </div>
  </v-fade-transition>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      showBasedOnUsedPercentage: {
        type: Boolean,
      },
      percentageLimit: {
        type: Number,
        required: false,
        default: 80
      }
    },

    data() {
      return {
        storageInfo: {
          limit_bytes: 0,
          limit_formatted: 0,
          used_bytes: 0,
          used_percentage: 0,
          used_formatted: 0,
        }
      }
    },

    computed: {
      show() {
        if (! this.showBasedOnUsedPercentage) {
          return true;
        }

        return this.storageInfo !== null && this.storageInfo.used_percentage >= this.percentageLimit;
      },

      color() {
        const percentage = this.storageInfo.used_percentage;
        if (percentage >= 80 && percentage < 95) {
          return 'amber';
        } else if (percentage >= 95) {
          return 'red';
        } else {
          return 'primary';
        }
      }
    },

    created() {
      this.getStorageUsage();
    },

    methods: {
      getStorageUsage() {
        axios.get(this.route('storage-usage'))
        .then(res => {
          this.storageInfo = res.data;
        })
      }
    }
  }
</script>